import { CthLeaderboardScreen } from '@/screens/completeTheHand/CthLeaderboardScreen'

export default function CthLeaderboardRoute() {
  return <CthLeaderboardScreen />
}
